import "./src/styles/global.css"
import './src/plugins/fontawesome/css/font-awesome.min.css';
import './src/plugins/line-awesome/css/line-awesome.min.css';
import './src/plugins/flaticon/flaticon.css';
import './src/plugins/flaticon/beer/flaticon.css';

export const registerServiceWorker = () => true

